import { Injectable } from '@angular/core';
import { decodeToken } from './jwt.util';

import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HttpErrorResponse,
} from '@angular/common/http';
import { Observable, catchError, of, tap, throwError, timeout } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ToastrService } from 'ngx-toastr';
import { AppInsightsService } from '../services/app-insights.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	authToken: string = '';
	constructor(
		private _oidcSecurityService: OidcSecurityService,
		private _toastr: ToastrService,
		private appInsightsService: AppInsightsService,
	) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
		const timeoutValue = environment.apiServiceTimeout * 1000;
		this.appInsightsService.logEvent('API call', { key: request.url });
		if (
			request.url.includes(environment.baseUrl) &&
			!request.url.includes('cms') &&
			!request.url.includes('access-request') &&
			!request.url.includes('match-maker/v1/free-cs')
		) {
			if (!this.authToken) {
				this.getAuthorizationToken();
			}
			return next
				.handle(
					request.clone({ setHeaders: { authorization: `Bearer ${this.authToken}` } }),
				)
				.pipe(
					timeout(timeoutValue),
					catchError((err: any) => {
						if (err.name === 'TimeoutError') {
							return throwError({
								status: 504,
								statusText: 'Request Timeout',
							});
						}
						if (err instanceof HttpErrorResponse) {
							if (err.status === 401) {
								this.logout('Session Expired. Logging out...');
							}
							if (err.status === 500) {
								// this.logout('Server Error. Please try again later.');
							}
						}
						// this.appInsightsService.logMetric('API Error', err);
						return throwError((): any => err);
					}),
				) as Observable<HttpEvent<any>>;
		} else if (request.url.includes('cms') || request.url.includes('access-request')) {
			return next
				.handle(
					request.clone({
						setHeaders: { 'Ocp-Apim-Subscription-Key': environment.cmsToken },
					}),
				)
				.pipe(
					timeout(timeoutValue),
					catchError((err: any) => {
						if (err.name === 'TimeoutError') {
							return throwError({
								status: 504,
								statusText: 'Request Timeout',
							});
						}
						// this.appInsightsService.logMetric('CMS Error', err);
						return throwError((): any => err);
					}),
				) as Observable<HttpEvent<any>>;
		}
		return next.handle(request);
	}

	getAuthorizationToken(): void {
		this._oidcSecurityService.checkAuth().subscribe(({ accessToken }) => {
			this.authToken = accessToken;
			// @ts-ignore
			//JWT token decode service
			(window as any).thisToken = decodeToken(accessToken);
		});
	}
	logout(message: string): void {
		this._toastr.error(message);
		setTimeout(() => {
			this._oidcSecurityService.logoff().subscribe((result) => console.log(result));
		}, 3000);
	}
}
